import $ from "jquery";
import ElementFilter from "../util/element_filter";
import ElementFilterForm from "../util/element_filter_form";

const configureFilterForm = function () {
  const filter = new ElementFilter($("#slide-decks"),
    ".card-container",
    [".card-title"]
  );

  const filterInput = $("#slide_deck_filter_filter");
  const form = filterInput.closest("form");

  new ElementFilterForm(form, filterInput, filter);
};

$(document).on("turbolinks:load", function () {
  configureFilterForm();
});
